<template>
  <div class="item-box" @click="gotoPath()">
    <i :class="[menu_item.icon, 'inline-block', 'text-3xl', 'text-red-400']"/>
    <p class="pt-2">{{ menu_item.name }}</p>
  </div>
</template>

<script>
export default {
  name: 'ItemBox',
  props: ['menu_item'],
  data() {
    return {}
  },
  methods: {
    gotoPath() {
      this.$emit('gotoPath')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>